import React, { useState } from "react";

const RateAction = ({
 rate,
 handleEditShippingRateClick,
 handleshippingRateDelete,
}) => {
 const [showOptions, setShowOptions] = useState(false);

 return (
  <div
   style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: "10px",
   }}
  >
   <p
    style={{
     background: "#F5F5F5",
     borderRadius: "8px",
     padding: "6px 12px",
     color: "#FF4D6B",
     marginTop: "-10px",
    }}
   >
    {rate.price}
   </p>

   {/* Ellipsis Button */}
   <button
    onClick={() => setShowOptions((prev) => !prev)}
    style={{
     background: "transparent",
     border: "none",
     cursor: "pointer",
     padding: "4px 8px",
     color: "#656CD9",
     marginTop: "-20px",
    }}
   >
    <i className="fa-solid fa-ellipsis-vertical"></i>
   </button>

   {/* Dropdown Options */}
   {showOptions && (
    <div
     style={{
      position: "absolute",
      top: "0",
      right: "20%",
      marginLeft: "100px",
      background: "#fff",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      borderRadius: "8px",
      padding: "6px",
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      zIndex: 100,
      minWidth: "100px",
     }}
    >
     <button
      style={{
       background: "transparent",
       border: "none",
       color: "#265ED7",
       cursor: "pointer",
       textAlign: "left",
       padding: "5px",
       borderRadius: "4px",
       fontWeight: "500",
       width: "100%",
      }}
      onClick={() => {
       handleEditShippingRateClick(rate);
       setShowOptions(false);
      }}
     >
      Edit
     </button>
     <button
      style={{
       background: "transparent",
       border: "none",
       color: "#FF4D6B",
       cursor: "pointer",
       textAlign: "left",
       padding: "5px",
       borderRadius: "4px",
       fontWeight: "500",
       width: "100%",
      }}
      onClick={() => {
       handleshippingRateDelete(rate.id);
       setShowOptions(false);
      }}
     >
      Delete
     </button>
    </div>
   )}
  </div>
 );
};

export default RateAction;
